import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import { WithTabTitle } from '../../../../common/widgets/withTabTitle';
import { AccountInfoPage } from '../../Pages/MyAccount/AccountInfoPage';
import { CardsPage } from '../../Pages/MyAccount/CardsPage';
import { BuyCardPage } from '../../Pages/MyAccount/CardsPage/BuyCardPage';
import { ReissueCardPage } from '../../Pages/MyAccount/CardsPage/ReissueCardPage';
import { TopUpCardPage } from '../../Pages/MyAccount/CardsPage/TopUpCardPages';
import { TransactionHistoryPage } from '../../Pages/MyAccount/CardsPage/TransactionHistoryPage';
import { ChangePasswordPage } from '../../Pages/MyAccount/ChangePasswordPage';
import { DashboardPage } from '../../Pages/MyAccount/DashboardPage';
import DemoAccountPage from '../../Pages/MyAccount/DemoAccountPage';
import { NotificationsPage } from '../../Pages/MyAccount/NotificationsPage';
import { OrdersPage } from '../../Pages/MyAccount/OrdersPage';
import { OrderDetailsPage } from '../../Pages/MyAccount/OrdersPage/OrderDetailsPage';
import { PreferencesPage } from '../../Pages/MyAccount/PreferencesPage';
import { SubscriptionsPage } from '../../Pages/MyAccount/SubscriptionsPage';
import { TimeAndAttendancePage } from '../../Pages/MyAccount/TimeAndAttendencePage';
import { AttendanceCheckInPage } from '../../Pages/MyAccount/TimeAndAttendencePage/AttendenceCheckInPage';
import { VouchersPage } from '../../Pages/MyAccount/VouchersPage';
import { WishlistPage } from '../../Pages/MyAccount/WishlistPage';
import MyBenefitsPage from '../../Pages/MyBenefitsPage';
import { resources } from '../../resources/resources';

const MyAccountRoutes = () => {
  const { t: translate } = useTranslation();
  return (
    <Routes>
      <Route
        path="dashboard"
        element={
          <WithTabTitle title={translate(resources.menu.dashboard)}>
            <DashboardPage />
          </WithTabTitle>
        }
      />
      <Route
        path="my-benefits"
        element={
          <WithTabTitle title={translate(resources.menu.myBenefits)}>
            <MyBenefitsPage />
          </WithTabTitle>
        }
      />
      <Route
        path="wishlist"
        element={
          <WithTabTitle title={translate(resources.menu.wishlist)}>
            <WishlistPage />
          </WithTabTitle>
        }
      />
      <Route
        path="account-info"
        element={
          <WithTabTitle title={translate(resources.menu.accountInfo)}>
            <AccountInfoPage />
          </WithTabTitle>
        }
      />
      <Route
        path="change-password"
        element={
          <WithTabTitle title={translate(resources.menu.passwordChange)}>
            <ChangePasswordPage />
          </WithTabTitle>
        }
      />
      <Route
        path="preferences"
        element={
          <WithTabTitle title={translate(resources.menu.preferences)}>
            <PreferencesPage />
          </WithTabTitle>
        }
      />
      <Route
        path="notifications"
        element={
          <WithTabTitle title={translate(resources.menu.notifications)}>
            <NotificationsPage />
          </WithTabTitle>
        }
      />
      <Route
        path="subscriptions"
        element={
          <WithTabTitle title={translate(resources.menu.subscriptions)}>
            <SubscriptionsPage />
          </WithTabTitle>
        }
      />
      <Route
        path="cards"
        element={
          <WithTabTitle title={translate(resources.menu.cards)}>
            <CardsPage />
          </WithTabTitle>
        }
      />
      <Route
        path="cards/top-up/:cardTypeId"
        element={
          <WithTabTitle title={translate(resources.employeeCards.topUp.title)}>
            <TopUpCardPage />
          </WithTabTitle>
        }
      />
      <Route
        path="cards/buy"
        element={
          <WithTabTitle title={translate(resources.menu.cards)}>
            <BuyCardPage />
          </WithTabTitle>
        }
      />
      <Route
        path="cards/reissue"
        element={
          <WithTabTitle title={translate(resources.menu.cards)}>
            <ReissueCardPage />
          </WithTabTitle>
        }
      />
      <Route
        path="cards/:cardId/history"
        element={
          <WithTabTitle title={translate(resources.menu.cards)}>
            <TransactionHistoryPage />
          </WithTabTitle>
        }
      />
      <Route
        path="vouchers"
        element={
          <WithTabTitle title={translate(resources.menu.vouchers)}>
            <VouchersPage />
          </WithTabTitle>
        }
      />
      <Route
        path="orders"
        element={
          <WithTabTitle title={translate(resources.menu.orders)}>
            <OrdersPage />
          </WithTabTitle>
        }
      />
      <Route path="orders/:orderId" element={<OrderDetailsPage />} />
      <Route
        path="time-and-attendance"
        element={
          <WithTabTitle title={translate(resources.menu.timeAndAttendance)}>
            <TimeAndAttendancePage />
          </WithTabTitle>
        }
      />
      <Route
        path="time-and-attendance/check-in"
        element={
          <WithTabTitle title={translate(resources.menu.checkIn)}>
            <AttendanceCheckInPage />
          </WithTabTitle>
        }
      />
      <Route
        path="create-demo-account"
        element={
          <WithTabTitle title={translate(resources.demoAccount.title)}>
            <DemoAccountPage />
          </WithTabTitle>
        }
      ></Route>
    </Routes>
  );
};

export default MyAccountRoutes;
